import React from "react";
import {
  Divider,
  Grid,
} from "@mui/material";
import InstanceTagTableRow from "./InstanceTagTableRow";
import { InstanceTagDTO, InstanceTagsType } from "./types";

export default function InstanceTagsTable (data: InstanceTagsType, header: string) {
    const instanceTags: InstanceTagDTO[] = [];
    const {applications, extensions} = data;
  
    if (applications) {
      Object.entries(applications).forEach(([key, {tag_name: tagName}]) => {
        instanceTags.push({
          type: "Application",
          image: key,
          tag: tagName,
        })
      });
    }
    if (extensions) {
      const {integrations, verticals} = extensions;
      if (integrations) {
        Object.entries(integrations).forEach(([key, {tag_name: tagName}]) => {
          instanceTags.push({
            type: "Extension",
            image: key,
            tag: tagName,
          })
        });
      }
      if (verticals) {
        Object.entries(verticals).forEach(([key, {tag_name: tagName}]) => {
          instanceTags.push({
            type: "Vertical",
            image: key,
            tag: tagName,
          })
        });
      }
    }
  
    if (instanceTags.length === 0) {
      instanceTags.push({
        type: "-",
        image: "-",
        tag: "-",
      })
    }
  
    return (
      <>
        <Grid item xs={12}> 
          <Divider orientation="horizontal" flexItem/>
        </Grid>
        {InstanceTagTableRow({
          type: header,
          image: "Name",
          tag: "Version",
        }, true)}
        {instanceTags.map((entry) => InstanceTagTableRow(entry))}
      </>
    )
  }